import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = accountId => {
  const items = [
    {
      icon: 'briefcase',
      key: 'subaccounts',
      label: 'SUBACCOUNTS',
      toState: frontendURL(`accounts/${accountId}/subaccounts`),
      toStateName: 'menu_subaccounts',
      roles: ['administrator'],
      accountTypes: ['parent_account'],
    },
    {
      icon: 'chat',
      key: 'conversations',
      label: 'CONVERSATIONS',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toStateName: 'home',
      roles: [
        'administrator',
        'agent',
        'seller',
        'supervisor',
        'team_supervisor',
        'analyzer',
        'assistant',
        'embed',
      ],
      accountTypes: ['account', 'subaccount'],
    },
    // {
    //   icon: 'telephone',
    //   key: 'calls',
    //   label: 'CALLS',
    //   toState: frontendURL(`accounts/${accountId}/calls`),
    //   toStateName: 'calls',
    //   roles: ['administrator', 'agent', 'supervisor', 'seller'],
    //   isBeta: true,
    // },
    {
      icon: 'priority-icon',
      key: 'priority_contacts',
      label: 'PRIORITY_CONTACTS',
      toState: frontendURL(`accounts/${accountId}/priority-contacts`),
      toStateName: 'priority_contacts',
      roles: [
        'administrator',
        'agent',
        'supervisor',
        'team_supervisor',
        'seller',
      ],
      isNew: false,
      isAttentionNeeded: true,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'calendar-clock',
      key: 'upcoming_scheduled_messages',
      label: 'UPCOMING_SCHEDULED_MESSAGES',
      toState: frontendURL(`accounts/${accountId}/upcoming-scheduled-messages`),
      toStateName: 'upcoming_scheduled_messages',
      roles: [
        'administrator',
        'agent',
        'supervisor',
        'team_supervisor',
        'seller',
      ],
      isNew: false,
      isAttentionNeeded: false,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'boards',
      iconFill: 'none',
      key: 'boards',
      label: 'BOARDS',
      toState: frontendURL(`accounts/${accountId}/boards`),
      toStateName: 'boards_dashboard',
      roles: [
        'administrator',
        'agent',
        'supervisor',
        'team_supervisor',
        'analyzer',
        'assistant',
      ],
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'table-switch',
      key: 'opportunities_kanban',
      label: 'OPPORTUNITIES',
      opportunityKanbanAccess: true,
      toState: frontendURL(`accounts/${accountId}/opportunities-kanban`),
      toStateName: 'opportunities_kanban',
      roles: [
        'administrator',
        'agent',
        'seller',
        'supervisor',
        'team_supervisor',
        'analyzer',
        'assistant',
      ],
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'book-contacts',
      key: 'contacts',
      label: 'CONTACTS',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
      roles: [
        'administrator',
        'agent',
        'supervisor',
        'team_supervisor',
        'seller',
        'analyzer',
        'assistant',
      ],
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'chat-multiple',
      key: 'internal_chat',
      label: 'INTERNAL_CHAT',
      featureFlag: FEATURE_FLAGS.INTERNAL_CHAT,
      toState: frontendURL(`accounts/${accountId}/internal-chat`),
      toStateName: 'internal_chat_dashboard',
      roles: [
        'administrator',
        'agent',
        'supervisor',
        'team_supervisor',
        'seller',
        'analyzer',
        'assistant',
      ],
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'arrow-trending-lines',
      key: 'reports',
      label: 'REPORTS',
      featureFlag: FEATURE_FLAGS.REPORTS,
      toState: frontendURL(`accounts/${accountId}/reports`),
      toStateName: 'settings_account_reports',
      roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
      accountTypes: ['account', 'subaccount', 'parent_account'],
    },
    {
      icon: 'automation',
      key: 'menu_dashboard_apps',
      label: 'DASHBOARD_APPS',
      toState: frontendURL(`accounts/${accountId}/dashboard-apps`),
      toStateName: 'menu_dashboard_apps',
      roles: ['administrator', 'supervisor'],
      accountTypes: ['account', 'subaccount', 'parent_account'],
    },
    {
      icon: 'settings',
      key: 'settings',
      label: 'SETTINGS',
      toState: frontendURL(`accounts/${accountId}/settings`),
      toStateName: 'settings_home',
      roles: [
        'administrator',
        'supervisor',
        'team_supervisor',
        'agent',
        'seller',
        'assistant',
        'analyzer',
      ],
      accountTypes: ['account', 'subaccount', 'parent_account'],
    },
  ];

  return items;
};

export default primaryMenuItems;
